import React from 'react';
import { Text, makeStyles, tokens } from '@fluentui/react-components';
import { useIsMobile } from '../hooks/useIsMobile';

interface FooterProps {
  txnCount: number;
  clearedBalance: number;
  unclearedBalance: number;
}

function formatMoney(amount: number): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
}

const useStyles = makeStyles({
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: tokens.colorNeutralBackground3,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalXL,
    paddingRight: tokens.spacingHorizontalXL,
    borderBottomLeftRadius: tokens.borderRadiusLarge,
    borderBottomRightRadius: tokens.borderRadiusLarge,
    borderLeft: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRight: `1px solid ${tokens.colorNeutralStroke2}`,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  mobileFooter: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    backgroundColor: tokens.colorNeutralBackground3,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    borderBottomLeftRadius: tokens.borderRadiusLarge,
    borderBottomRightRadius: tokens.borderRadiusLarge,
    borderLeft: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRight: `1px solid ${tokens.colorNeutralStroke2}`,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  totals: {
    display: 'flex',
    gap: tokens.spacingHorizontalXL,
  },
  mobileTotals: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export const Footer: React.FC<FooterProps> = ({ txnCount, clearedBalance, unclearedBalance }) => {
  const styles = useStyles();
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className={styles.mobileFooter}>
        <Text size={200} weight="regular">
          {txnCount} transaction{txnCount !== 1 ? 's' : ''}
        </Text>
        <div className={styles.mobileTotals}>
          <Text size={200}>Cleared: <Text weight="semibold">{formatMoney(clearedBalance)}</Text></Text>
          <Text size={200}>Uncleared: <Text weight="semibold">{formatMoney(unclearedBalance)}</Text></Text>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.footer}>
      <Text size={200} weight="regular">
        {txnCount} transaction{txnCount !== 1 ? 's' : ''}
      </Text>
      <div className={styles.totals}>
        <Text size={200}>Cleared: <Text weight="semibold">{formatMoney(clearedBalance)}</Text></Text>
        <Text size={200}>Uncleared: <Text weight="semibold">{formatMoney(unclearedBalance)}</Text></Text>
      </div>
    </div>
  );
};
